/* eslint-disable react/prop-types */
import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Button,
  makeStyles,
  Box,
} from "@material-ui/core";
import CheckboxComponent from "app/common/CheckboxComponent";

const useStyles = makeStyles((theme) => ({
  dialogTitle: {
    borderBottom: theme.box.border,
    backgroundColor: theme.palette.primary.main,
    color: "white",
  },
  dialogContent: {
    padding: "25px",
  },
  dialogActions: {
    borderTop: theme.box.border,
  },
  checkboxContainer: {
    flex: 1,
  },
  inAnimation: {
    "& > div > div": {
      animation: "$boing 700ms ease-in-out",
    },
  },
  "@keyframes boing": {
    "15%, 40%, 75%, 100% ": {
      transformOrigin: "center center",
    },
    "15%": {
      transform: "scale(1.2, 1.2)",
    },
    "40%": {
      transform: "scale(0.95, 0.95)",
    },
    "75%": {
      transform: "scale(1.05, 1.05)",
    },
    "100%": {
      transform: "scale(1, 1)",
    },
  },
}));

export default ({
  title,
  content,
  onConfirmAction,
  open = false,
  onCheckboxChecked,
  isCheckboxComponent = false,
  isCancelComponent = true,
  confirmText,
  isInAnimation = false,
}) => {
  const classes = useStyles();

  return (
    <Dialog open={open} className={isInAnimation && classes.inAnimation}>
      <DialogTitle className={classes.dialogTitle}>
        {title ?? "Need confirmation"}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        {content ?? "Do you want to proceed?"}
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        {isCheckboxComponent ? (
          <Box className={classes.checkboxContainer}>
            <CheckboxComponent
              label="Don’t ask me again for this cycle"
              labelPlacement="start"
              checkboxOnchange={(e) => onCheckboxChecked(e.target.checked)}
              checkboxName="dialogCheckbox"
              checkboxSize="medium"
              checkboxColor="primary"
            />
          </Box>
        ) : null}
        {isCancelComponent && (
          <Button autoFocus onClick={(e) => onConfirmAction(e, false)}>
            CANCEL
          </Button>
        )}
        <Button
          autoFocus
          onClick={(e) => onConfirmAction(e, true)}
          variant="contained"
          color="primary"
        >
          {confirmText || "Yes"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
